import type { OptionsObject } from 'notistack'

export const errorSnackbarOptions: OptionsObject<'error'> = {
  persist: true,
  variant: 'error',
}
